import { UsersAPI } from "../APIs/users.api";
import { UserWithDetails } from "../types/user.types";
import {
  createContext,
  useCallback,
  useContext,
  useState,
} from "react";

export interface UsersType {
  users: UserWithDetails[] | null;
  isLoading: boolean;
  error: string | null;
  getUsers: () => Promise<void>;
}

const UsersContext = createContext<UsersType | undefined>(undefined);

export const UsersProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [users, setUsers] = useState<UserWithDetails[] | null>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const getUsers = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await UsersAPI.getAllUsers();
      if (response.statusCode === 200) {
        const data = await response.data;
        if (Array.isArray(data)) {
          setUsers(data);
        } else {
          setUsers(null);
        }
      } else {
        setError("Error al obtener los usuarios");
      }
    } catch (error) {
      setError("Error de conexión");
    } finally {
      setIsLoading(false);
    }
  }, []);

  return (
    <UsersContext.Provider
      value={{
        users,
        isLoading,
        error,
        getUsers,
      }}
    >
      {children}
    </UsersContext.Provider>
  );
};

export const useUsers = () => {
  const context = useContext(UsersContext);
  if (!context) {
    throw new Error("useUsers must be used within a UsersProvider");
  }
  return context;
};
